import { MdWorkOutline, MdOutlineCalendarMonth } from "react-icons/md";
import { AiOutlineEuro } from "react-icons/ai";


export const historyConf = {
    "datetimeField": "created_at",
    "showInfo": [
        {
            "icon": <MdWorkOutline className="icon" />,
            "field": "codice_fiscale"
        },
        {
            "icon": <MdOutlineCalendarMonth className="icon" />,
            "field": "data_denuncia"
        },
        {
            "icon": <AiOutlineEuro className="icon" />,
            "field": "somma_debito"
        }
    ]
};
